import React from 'react';
import Image from 'next/image';

import PlusBolt from '~/public/font-awesome/plus-solid-bolt.png';

interface ManualCouponButtonProps {
  onClick: () => void;
  label: string;
}

export default React.memo(function ManualCouponButton({
  onClick,
  label,
}: Readonly<ManualCouponButtonProps>): React.ReactElement {
  return (
    <button
      className="flex items-center text-center text-sm text-bolt hover:underline md:mr-0 md:mt-0"
      onClick={onClick}
    >
      <Image
        height={16}
        width={16}
        src={PlusBolt}
        alt="error-circle"
        className="mr-2 inline-block"
      />
      {label}
    </button>
  );
});
